export var ApiIntegrationIncludes = {
    configurations: true,
    transactions: { include: { logs: true } },
};
//# sourceMappingURL=ApiIntegration.js.map